import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ModifiersUtils } from 'react-day-picker'
import { isSameDate } from 'tools/date'
import { numberise } from 'tools/style'
import { padding, paddingSizes, borderRadiusSizes, dropShadowVariations, marginSizes, colorConstants } from 'theme/default'
import Flex from 'components/Flex'
import { Grid, Row, Column } from 'components/Grid'
import { H1, P, SmallText } from 'components/Typo'

const DayContainer = styled(Flex).attrs(() => ({
  flexDirection: 'column',
  padding: paddingSizes.small,
  alignItems: 'center',
  flexGrow: 1,
  borderRadius: borderRadiusSizes.small,
  boxShadow: dropShadowVariations.light
}))`
  border: 2px ${props => props.selected ? colorConstants.matteBlack : colorConstants.lightGray} solid;
  background-color: ${colorConstants.white};
  padding-left: 0;
  padding-right: 0;
  z-index: 10;
  ${props => props.disabled ? `
    opacity: 0.5;
  ` : `
    cursor: pointer;
  `}

  &:hover {
    ${props => props.disabled ? '' : `border: 2px ${colorConstants.matteBlack} solid;`}
  }
`

const Day = ({ dayOfWeek, dayOfMonth, month, onClick, selected, disabled }) => (
  <DayContainer onClick={onClick} selected={selected} disabled={disabled}>
    <SmallText line={1} bold normalised marginBottom={marginSizes.small} color={colorConstants.matteBlack}>{(dayOfWeek || '').toUpperCase()}</SmallText>
    <H1 bold normalised color={colorConstants.matteBlack}>{dayOfMonth}</H1>
    <P line={1} bold normalised color={colorConstants.matteBlack}>{(month || '').toUpperCase()}</P>
  </DayContainer>
)
Day.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  dayOfWeek: PropTypes.string.isRequired,
  dayOfMonth: PropTypes.number.isRequired,
  month: PropTypes.string.isRequired
}

const gutterSize = numberise(padding[paddingSizes.small])

const SimpleDatePicker = ({ name, onChange = () => {}, selectedDay, disabledDays = [], days = [] }) => (
  <Grid>
    <Row gutterSize={gutterSize}>
      {(days).map(({ day, dayOfWeek, dayOfMonth, month }, index) => {
        const disabled = ModifiersUtils.dayMatchesModifier(day, disabledDays)
        const selected = selectedDay && isSameDate(selectedDay, day)
        return (
          <Column key={index} sm={12 / 5} gutterSize={gutterSize}>
            <Day
              month={month}
              dayOfWeek={dayOfWeek}
              dayOfMonth={dayOfMonth}
              disabled={disabled}
              selected={selected}
              onClick={() => !disabled && !selected && onChange(name, day)}
            />
          </Column>
        )
      })}
    </Row>
  </Grid>
)

SimpleDatePicker.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  selectedDay: PropTypes.object,
  disabledDays: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  days: PropTypes.arrayOf(PropTypes.shape({
    day: PropTypes.object.isRequired,
    dayOfWeek: PropTypes.string.isRequired,
    dayOfMonth: PropTypes.number.isRequired,
    month: PropTypes.string.isRequired
  }))
}

export default SimpleDatePicker
